export function parseBreakStartMs(iso) {
    if (!iso?.trim())
        return null;
    const ms = new Date(iso).getTime();
    return Number.isNaN(ms) ? null : ms;
}
